// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Action
import { setFundChartSecurityGroup } from './security-group.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const securityGroup = createReducer('', on(setChartData, (state, { chartData }) => chartData.params.securityGroup), on(setFundChartSecurityGroup, (state, { securityGroup: newSecurityGroup }) => newSecurityGroup));
